import React from "react";
import { StarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSetHotelServiceFeatured } from "@/hooks/useHotelServices";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

const RecommendedCell = ({
  id,
  hotelId,
  isRecommended,
  canToggleRecommended,
}: {
  id: string;
  hotelId: string;
  isRecommended: boolean;
  canToggleRecommended: boolean;
}) => {
  const { t } = useTranslation();
  const { mutateAsync, isPending } = useSetHotelServiceFeatured();

  const starClassName = cn(
    "h-4 w-4",
    isRecommended
      ? "fill-[var(--service-recommended-fill)] text-[var(--service-recommended-fill)]"
      : "fill-transparent text-[var(--service-recommended-stroke)]",
  );

  if (!canToggleRecommended) {
    return (
      <span
        className="inline-flex h-8 w-8 shrink-0 items-center justify-center"
        role="status"
        aria-label={
          isRecommended
            ? t("services.page.table.recommendedActive", "Recommended")
            : t("services.page.table.recommendedInactive", "Not recommended")
        }
      >
        <StarIcon className={starClassName} aria-hidden />
      </span>
    );
  }

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon_sm"
      className="shrink-0"
      disabled={isPending}
      aria-pressed={isRecommended}
      aria-label={t(
        "services.page.table.toggleRecommended",
        "Toggle recommended service",
      )}
      onClick={(event) => {
        event.stopPropagation();
        void mutateAsync({ id, hotelId, isRecommended: !isRecommended });
      }}
    >
      <StarIcon className={starClassName} />
    </Button>
  );
};

export default RecommendedCell;
